import { render, staticRenderFns } from "./DashboardWordCloud.vue?vue&type=template&id=7f2f0dd6"
import script from "./DashboardWordCloud.vue?vue&type=script&lang=js"
export * from "./DashboardWordCloud.vue?vue&type=script&lang=js"
import style0 from "./DashboardWordCloud.vue?vue&type=style&index=0&id=7f2f0dd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports